import { useState } from 'react'
import Swal from 'sweetalert2'
import {
    getAllFamilias,
    saveFamiliasImportar
} from '../../../Services/familiaService'
import { familiasExcel } from '../../../Services/reporteService'
import showImportResult, { showImportError } from '../../../utils/showImportResult'

const useFamily = () => {
    const [file, setFile] = useState()
    const [loading, setLoading] = useState(false)

    //funciones comunes:
    const handleImprimir = async () => {
        try {
            const familias = await getAllFamilias(true, 0, '', 50000)
            const excel = await familiasExcel(familias.data.content, null)

            const byteCharacters = atob(excel.data)
            const byteNumbers = new Array(byteCharacters.length)
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i)
            }
            const byteArray = new Uint8Array(byteNumbers)
            const blob = new Blob([byteArray], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            })

            const url = window.URL.createObjectURL(blob)
            const link = document.createElement('a')
            link.href = url
            link.download = 'familias.xlsx'
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            window.URL.revokeObjectURL(url)
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Hubo un problema al generar el archivo.',
                showConfirmButton: true,
            })
        }
    }

    //AddFamiliaImportar.js
    const addFamiliaSubmit = (e) => {
        e.preventDefault()
        setLoading(true)

        const formData = new FormData()
        formData.append('file', file)

        saveFamiliasImportar(formData)
            .then((data) => {
                showImportResult(data, 'familias')
            })
            .catch(() => {
                showImportError('familias')
            })
            .finally(() => {
                setLoading(false)
            })
    }

    return {
        handleImprimir,
        loading,
        addFamiliaSubmit,
        setFile,
        file,
    }
}

export default useFamily
